import React, { useState, useImperativeHandle  } from 'react'
import { useFormik, FieldArray, FormikProvider } from 'formik'
import moment from 'moment';

// components
import InputField from '../../../../../components/forms/InputField/InputField.component';
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import AsyncSelectField from '../../../../../components/forms/AsyncSelectField/AsyncSelectField.component';
import ActionButton from '../../../../../components/buttons/ActionButton/ActionButton.component';
import ReceivingEquipmentInput from '../../../../../components/forms/lists/ReceivingEquipmentInput/ReceivingEquipmentInput.component';

// queries
import { GET_ALL_EQUIPMENT_FOR_SELECT_FIELD } from '../../../../../graphql/equipment/equipment.queries';

const ReceivingOther = React.forwardRef(({ errors }, ref) => {
    const [ selectedEquipment, setSelectedEquipment ] = useState(null)

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: {
            date: moment(),
            time: moment(),
            equipment: [],
            equipmentSearch: '',
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <InputField 
                id="date"
                placeholder="Date"
                type="date"
                onChange={value => formik.setFieldValue('date', value)}
                value={formik.values.date}
                isValid={errors['date']}
            />

            <InputField 
                id="time"
                placeholder="Time"
                type="time"
                onChange={value => formik.setFieldValue('time', value)}
                value={formik.values.time}
                isValid={errors['time']}
            />

            <FieldArray 
                name='equipment'
                render={({ remove, push }) => (
                    <div>
                        <FormSectionHeader text='Equipment' />
                        <div className='select-and-add'>
                            <div className='select-and-add-left'>
                                <AsyncSelectField 
                                    id="equipmentSearch"
                                    value={formik.values.equipmentSearch}
                                    placeholder="Search"
                                    onChange={value => { 
                                        setSelectedEquipment(value.data)
                                        formik.setFieldValue('equipmentSearch', value.value)
                                    }}
                                    query={{
                                        query: GET_ALL_EQUIPMENT_FOR_SELECT_FIELD,
                                        rules: {
                                            loopField: 'allEquipment',
                                            label: ['sku', 'name'],
                                            value: 'id',
                                            groupBy: 'category.name'
                                        }
                                    }}
                                    grouped
                                    showRequired={false}
                                />
                            </div>
                            <div className='select-and-add-right'>
                                <ActionButton label='Add' disabled={selectedEquipment == null} onClick={(e) => {
                                    e.preventDefault();
                                    push({...selectedEquipment, quantityReceived: ''})
                                }} />
                            </div>
                        </div>

                        {
                            formik.values.equipment.map((item, index) => {
                                return (<ReceivingEquipmentInput 
                                    key={index}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    title={item.name}
                                    subTitle={null}
                                    qtyReceived={item.quantityReceived}
                                    errors={errors['equipment'].length > index ? errors['equipment'][index] : {}}
                                    handleRemove={(e) => {
                                        e.preventDefault()
                                        remove(index)
                                    }}
                                />)
                            })
                        }
                    </div>
                )}
            />        
        </form>
    </FormikProvider>)
})

export default ReceivingOther